import React from 'react';
import './App.scss';
import Layout from './Components/layout/layout';

function App() {
  
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
